import useMediaQuery from '@mui/material/useMediaQuery';
import { useGetTheme } from './useGetTheme';

export const useIsMobile = () => {
  const theme = useGetTheme();
  return { isMobile: useMediaQuery(theme.breakpoints.mobile) };
};
